import {Text} from "@pg-design/text";
import {rpAppLink} from "@pg-mono/rp-routes";
import {propertyOffer} from "@pg-mono/string-utils";
import {ISuggestedRegion, SUGGESTED_REGIONS_POLAND, SUGGESTED_REGIONS_SPAIN} from "@pg-rp/common-constants";

import {offerUrlBuilder} from "../../offer/helpers/friendly_offer_list/offer_url_builder";
import {getCountryName} from "../../offer/list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {Country} from "../../region/types/Country";
import {fetchSingleRegionSimple} from "../actions/fetch_search_regions_action";
import {useTrackAmplitudeGlobalSearch} from "../tracking/use_track_amplitude_global_search";
import {SearchTab} from "../types/SearchTab";
import {addNewRegionToCurrentRegions} from "../utils/add_new_region_to_current_regions";
import {resultsList} from "./atoms/atoms";
import {ResultsListItem} from "./atoms/ResultsListItem";
import {ISearchInputValue} from "./ISearchInputValue";
import {RecentFiltersSearch} from "./RecentFiltersSearch";

interface IProps {
    activeItemId: number | null;
    country?: Country;
    hideRecentFilters?: boolean;
    onLinkClick: (option: ISearchInputValue) => void;
}

export const SuggestedRegions = (props: IProps) => {
    const {activeItemId, country, hideRecentFilters, onLinkClick} = props;

    const {buildAmplitudeSearchQuery, currentSearch, setPendingAmplitudeSearch} = useTrackAmplitudeGlobalSearch();

    const isSpain = country === Country.SPAIN;
    const shouldShowRecentFilters = country === Country.POLAND && !hideRecentFilters;
    const suggestedRegionList = isSpain ? SUGGESTED_REGIONS_SPAIN : SUGGESTED_REGIONS_POLAND;

    const handleSuggestedRegionClick = async (item: ISuggestedRegion) => {
        const suggestedRegion = await fetchSingleRegionSimple(item.id);
        const combinedRegions =
            currentSearch?.tabType === SearchTab.Regions ? addNewRegionToCurrentRegions(currentSearch.regions, suggestedRegion) : [suggestedRegion];
        const searchValue: ISearchInputValue = {
            label: suggestedRegion.full_name_reverted,
            tabType: SearchTab.Regions,
            regions: combinedRegions
        };
        const totalOffersCount = combinedRegions.reduce(
            (sum, region) => sum + (suggestedRegionList.find((entry) => entry.id === region.id)?.offerCount ?? 0),
            0
        );
        // Stage the event instead of firing immediately — on homepage the user must click
        // the submit button first; on listing page the auto-submit path fires it instead.
        setPendingAmplitudeSearch(buildAmplitudeSearchQuery(searchValue), "popular_search_click", totalOffersCount || undefined);
        onLinkClick(searchValue);
    };

    const handleAllSpainResultsClick = () => {
        const {friendlySlug} = offerUrlBuilder({region: ""});
        window.location.href = rpAppLink.offer.listFriendlyAbroad({
            friendlySlug,
            country: getCountryName(Country.SPAIN)
        });
    };

    return (
        <>
            {shouldShowRecentFilters && <RecentFiltersSearch />}

            <Text variant="mini_header" style={{display: "block", marginBottom: "1rem"}}>
                Najczęściej wybierane
            </Text>

            <ul css={resultsList}>
                {isSpain && <ResultsListItem title="Wszystkie lokalizacje w Hiszpanii" onClick={handleAllSpainResultsClick} />}

                {suggestedRegionList.map((item, idx) => {
                    const propertiesCount = item.offerCount;
                    const propertiesFormat = propertyOffer.nominative(propertiesCount);

                    return (
                        <ResultsListItem
                            key={idx}
                            idx={idx}
                            activeItemId={activeItemId}
                            onClick={() => handleSuggestedRegionClick(item)}
                            title={item.label}
                            subTitle={item.regionFull}
                            countLabel={`${propertiesCount} ${propertiesFormat}`}
                        />
                    );
                })}
            </ul>
        </>
    );
};
import {Text} from "@pg-design/text";
import {rpAppLink} from "@pg-mono/rp-routes";
import {propertyOffer} from "@pg-mono/string-utils";
import {ISuggestedRegion, SUGGESTED_REGIONS_POLAND, SUGGESTED_REGIONS_SPAIN} from "@pg-rp/common-constants";

import {offerUrlBuilder} from "../../offer/helpers/friendly_offer_list/offer_url_builder";
import {getCountryName} from "../../offer/list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {Country} from "../../region/types/Country";
import {fetchSingleRegionSimple} from "../actions/fetch_search_regions_action";
import {useTrackAmplitudeGlobalSearch} from "../tracking/use_track_amplitude_global_search";
import {SearchTab} from "../types/SearchTab";
import {addNewRegionToCurrentRegions} from "../utils/add_new_region_to_current_regions";
import {resultsList} from "./atoms/atoms";
import {ResultsListItem} from "./atoms/ResultsListItem";
import {ISearchInputValue} from "./ISearchInputValue";
import {RecentFiltersSearch} from "./RecentFiltersSearch";

interface IProps {
    activeItemId: number | null;
    country?: Country;
    hideRecentFilters?: boolean;
    onLinkClick: (option: ISearchInputValue) => void;
}

export const SuggestedRegions = (props: IProps) => {
    const {activeItemId, country, hideRecentFilters, onLinkClick} = props;

    const {buildAmplitudeSearchQuery, currentSearch, setPendingAmplitudeSearch} = useTrackAmplitudeGlobalSearch();

    const isSpain = country === Country.SPAIN;
    const shouldShowRecentFilters = country === Country.POLAND && !hideRecentFilters;
    const suggestedRegionList = isSpain ? SUGGESTED_REGIONS_SPAIN : SUGGESTED_REGIONS_POLAND;

    const handleSuggestedRegionClick = async (item: ISuggestedRegion) => {
        const suggestedRegion = await fetchSingleRegionSimple(item.id);
        const combinedRegions =
            currentSearch?.tabType === SearchTab.Regions ? addNewRegionToCurrentRegions(currentSearch.regions, suggestedRegion) : [suggestedRegion];
        const searchValue: ISearchInputValue = {
            label: suggestedRegion.full_name_reverted,
            tabType: SearchTab.Regions,
            regions: combinedRegions
        };
        const totalOffersCount = combinedRegions.reduce(
            (sum, region) => sum + (suggestedRegionList.find((entry) => entry.id === region.id)?.offerCount ?? 0),
            0
        );
        // Stage the event instead of firing immediately — on homepage the user must click
        // the submit button first; on listing page the auto-submit path fires it instead.
        setPendingAmplitudeSearch(buildAmplitudeSearchQuery(searchValue), "popular_search_click", totalOffersCount || undefined);
        onLinkClick(searchValue);
    };

    const handleAllSpainResultsClick = () => {
        const {friendlySlug} = offerUrlBuilder({region: ""});
        window.location.href = rpAppLink.offer.listFriendlyAbroad({
            friendlySlug,
            country: getCountryName(Country.SPAIN)
        });
    };

    return (
        <>
            {shouldShowRecentFilters && <RecentFiltersSearch />}

            <Text variant="mini_header" style={{display: "block", marginBottom: "1rem"}}>
                Najczęściej wybierane
            </Text>

            <ul css={resultsList}>
                {isSpain && <ResultsListItem title="Wszystkie lokalizacje w Hiszpanii" onClick={handleAllSpainResultsClick} />}

                {suggestedRegionList.map((item, idx) => {
                    const propertiesCount = item.offerCount;
                    const propertiesFormat = propertyOffer.nominative(propertiesCount);

                    return (
                        <ResultsListItem
                            key={idx}
                            idx={idx}
                            activeItemId={activeItemId}
                            onClick={() => handleSuggestedRegionClick(item)}
                            title={item.label}
                            subTitle={item.regionFull}
                            countLabel={`${propertiesCount} ${propertiesFormat}`}
                        />
                    );
                })}
            </ul>
        </>
    );
};
